import React, { useState, useEffect } from 'react';
import {
  Row, Input, Button, Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { postAPI_Create_QuestionSet, putAPI_Update_QuestionSet } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../gallery/index'


function QuestionSetForm({
  /** Globle property id from redux */
  propertyId,
  CancelQuestionSet,
  loadResponse,
  setName,
  setId,
  updateSet,
  type
}) {
  const [buttonTextInput, setButtonTextInput] = useState(setName == undefined ? '' : setName);
  const [seriesType, setSeriesType] = useState(type == undefined ? 'Products' : type);
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    PropertyId: propertyId,
    Name: '',
    Status: 'Active',
    Creator: 'Dashboard',
    Type: 'Products'
  });

  useEffect(() => {
    setPostData({ ...postData, Name: buttonTextInput, Type: seriesType })
  }, [buttonTextInput, seriesType]);

  const handleCaptionChange = e => {
    setButtonTextInput(e.target.value);
  };
  const handleTypeChange = e => {
    setSeriesType(e.target.value);
  };

  const handleSave = async () => {
    if (setId === undefined) {
      try {
        return await AxiosAPI({
          method: 'post',
          url: `${postAPI_Create_QuestionSet}`,
          data: postData,
        })
          .then(() => {
            console.log("added")
          })
          .finally(
            setTimeout(() => {
              CancelQuestionSet();
              loadResponse();
            }, 1000)
          );
      } catch (error) {
        console.error(error);
      }
    }
    else {
      let data = {
        Name: buttonTextInput,
        Type: seriesType,
        Status: 'Active',
        Updater: 'Dashboard'
      }
      try {
        return await AxiosAPI({
          method: 'put',
          url: `${putAPI_Update_QuestionSet}/${setId}`,
          data: data,
        })
          .then(() => {
            updateSet(buttonTextInput)
          });
      } catch (error) {
        console.error(error);
      }
    }

  };

  const handleCancel = () => {
    CancelQuestionSet();
    // if (setIsEditingToFalse) {
    //   setIsEditingToFalse();
    // }
    // if (setIsAddImageToFalse) {
    //   setIsAddImageToFalse();
    // }
    // toggleButtonAddedd();
    // toggleButtonMessageAddedd();
  };
  return (
    <div>
      <Row>
        {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}

        <Colxx xxs="12" className="mb-3">
          <Input
            type="text"
            value={buttonTextInput}
            onChange={handleCaptionChange}
            placeholder="Enter the name"
          ></Input>
        </Colxx>
        <Colxx xxs="12" className="mb-3">
          <Input
            type="select"
            value={seriesType}
            name="type"
            onChange={handleTypeChange}>
            <option value="Products">Products</option>
            <option value="Rooms">Rooms</option>
            <option value="Addons">Addons</option>
            <option value="Promos">Promos</option>
          </Input>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="12">
          <div
            className="float-right"
            style={{ marginTop: ' 5px', marginBottom: '5px' }}
          >
            <Button
              color="secondary"
              className="add-button"
              size="xs"
              onClick={handleSave}
            >
              Save
            </Button>
            <b> </b>
            <Button
              color="light"
              className="add-button"
              size="xs"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Colxx>
      </Row>

    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps)(QuestionSetForm));
